/*
 * *****************************************************************************
 *     Copyright (C)  Motorola Solutions, INC.
 *     All Rights Reserved.
 *     Motorola Solutions Confidential Restricted.
 * *****************************************************************************
 */

import { Injectable, OnDestroy } from '@angular/core';
import { linkedCallUpdate } from '../+state/call.actions';
import { Store } from '@ngrx/store';
import { StompBaseConsumer } from '../../core/abstract/stomp-base-consumer';
import { StompManagerService } from '../../core/services/stomp-manager/stomp-manager.service';
import { Call } from 'CalltakingCoreApi';
import { Topic } from '../../user/model/multiple-subscriptions';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RemoteAgencyCallSyncService extends StompBaseConsumer implements OnDestroy {
    private readonly remoteCallTopicSubscription: Subscription | undefined;

    constructor(
        protected store: Store,
        protected stompManager: StompManagerService
    ) {
        super(stompManager, store);
    }

    protected handleLinkedCallUpdateMessage(call: Call) {
        this.store.dispatch(linkedCallUpdate({call}));
    }

    protected getTopics(): Topic[] {
        return [Topic.REMOTE_CALL];
    }

    protected getTopicHandlers(): { [p in Topic]?: (message: any) => void } {
        return {
            [Topic.REMOTE_CALL]: this.handleLinkedCallUpdateMessage.bind(this),
        };
    }

    handleSubscriptionInit(topic: string, receiptId: string, clusterName?: string, clusterLabel?: string): void {
        console.info(`${clusterLabel ? clusterLabel : ''} Linked Call topic ${topic} subscription success: ${receiptId}`);
    }

    handleSubscriptionEnd(topic: string, receiptId: string, clusterName?: string, clusterLabel?: string): void {
        console.info(`${clusterLabel ? clusterLabel : ''} Linked Call topic ${topic} subscription end: ${receiptId}`);
    }

    handleStompError(topic: string, receiptId: string, error: string, clusterName?: string, clusterLabel?: string): void {
        console.info(`${clusterLabel ? clusterLabel : ''} Linked Call topic ${topic} subscription failed=${error} for receiptId=${receiptId}`);
    }

    ngOnDestroy(): void {
        if (this.remoteCallTopicSubscription) {
            this.remoteCallTopicSubscription.unsubscribe();
        }
    }
}
